import client from '../client';

export const relayPointApis = {
  getDataPointUser: (data: any) => client.get(`/relaypoint/user`, { params: data }),
  getRelayPointOrderList: ({
    searchType,
    searchWord,
    page,
    size,
    statusCd,
  }: {
    searchType: string;
    searchWord: string;
    page: number;
    size: number;
    statusCd: number;
  }) =>
    client.get(
      `/relaypoint/ordersheet/list?searchType=${searchType}&keyword=${searchWord}&limit=${size}&page=${page}&statuscd=${statusCd}`,
    ),
  postRelayPointRefund: (data: { impUid: string; amount: number }) => client.post(`/relaypoint/payment/refundaccept`, data),
};
